import React, { useState } from 'react'
import { useHumanHandoverStore } from '@/stores/humanHandover/humanHandoverStore'
import { updateChatFileSettings } from '@/services/humanHandover'
import useToast from '@/hooks/useToast'

const EnableFileButton = ({
  onCancel,
  onEnableFile,
  className = '',
  conversationId
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const { setFileUploadSetting, setExplicitlyEnabledFileUpload } = useHumanHandoverStore()
  const { addSuccessToast, addErrorToast } = useToast()



  const handleEnableFileUpload = async () => {
    if (!conversationId) {
      addErrorToast('Conversation ID is required')
      return
    }

    try {
      setIsLoading(true)

      // Call the new API to enable file upload for this specific conversation
      await updateChatFileSettings(conversationId, true)

      setFileUploadSetting(true)

      // Mark that file upload was explicitly enabled during this conversation
      setExplicitlyEnabledFileUpload(true)

      addSuccessToast({message: 'File upload enabled successfully'})

      if (onEnableFile) {
        onEnableFile()
      }
    } catch (error) {
      addErrorToast(
        error?.response?.data?.detail ||
        error?.message ||
        'Failed to enable file upload'
      )
    } finally {
      setIsLoading(false)
    }
  }
  return (
    <div className={`flex items-start gap-[10px] self-stretch ${className}`}>
     
      <button
        onClick={onCancel}
        className="flex h-10 px-6 py-[10px] flex-col justify-center items-center flex-1 rounded-v3-md bg-[#E0DBFF] hover:bg-[#D1C7FF] transition-colors duration-200"
      >
        <span className="text-center text-[#5745FA] font-inter-variable text-sm font-medium leading-[160%]">
          Cancel
        </span>
      </button>

     
      <button
        onClick={handleEnableFileUpload}
        disabled={isLoading}
        className="flex h-10 px-6 py-[10px] flex-col justify-center items-center flex-1 rounded-v3-md bg-v3-purple-primary hover:bg-v3-purple-dark transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span className="text-center text-[#fff] font-inter-variable text-sm font-medium leading-[160%]">
          {isLoading ? 'Enabling...' : 'Enable file upload'}
        </span>
      </button>
    </div>
  );
};

export default EnableFileButton